export default __webpack_public_path__ + "static/media/welcome_onboard.4e7b039d.svg";